import { _ as _objectWithoutProperties, a as _extends, f as _typeof } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { ButtonArrow } from './button-arrow.js';

var styles = {
raw: ".hcr-connection-1-6-0{width:100%;margin-bottom:24px;border-collapse:collapse}.hcr-connection__station-1-6-0,.hcr-connection__station-info-1-6-0,.hcr-connection__station-toggler-1-6-0{position:relative;margin-left:28px}.hcr-connection__station-1-6-0:after,.hcr-connection__station-info-1-6-0:after,.hcr-connection__station-toggler-1-6-0:after{display:block;position:absolute;top:-.6875em;bottom:-.6875em;left:-24px;width:1px;background:#8b8b8b;content:\"\";z-index:1}.hcr-connection__station-info-1-6-0:after{top:0}.hcr-connection__station-info-1-6-0{padding:2px 4px;background:#f7f7f7}.hcr-connection__station-toggler-1-6-0 a{font-size:16px}tr:last-child .hcr-connection__station-info-1-6-0:after{display:none}.hcr-connection__station-1-6-0:before{position:absolute;top:.6875em;left:-24px;width:7px;height:1px;background:#8b8b8b;content:\"\";vertical-align:middle;z-index:2}.hcr-connection__title-1-6-0{margin-bottom:6px;font-weight:700;text-align:left}.hcr-connection__title-arrival-1-6-0{font-weight:300}.hcr-connection__day-1-6-0{font-size:10px;font-weight:300;line-height:1;vertical-align:text-top}.hcr-connection__time-1-6-0 .hcr-connection__day-1-6-0{position:absolute}.hcr-connection__time-1-6-0{padding-right:17px;white-space:nowrap}.hcr-connection__time--warning-1-6-0{color:#ffad00}.hcr-connection__time--old-1-6-0{color:#8b8b8b;text-decoration:line-through}.hcr-connection__time--danger-1-6-0{color:#ff5700}.hcr-connection__ellipsis-1-6-0{width:0;min-width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.hcr-connection-1-6-0 tr:first-child .hcr-connection__station-1-6-0:before,.hcr-connection-1-6-0 tr:last-child .hcr-connection__station-1-6-0:before{display:inline-block;top:12px;left:-28px;width:9px;height:9px;margin-top:-5px;border:1px solid #8b8b8b;border-radius:50%;background:#8b8b8b;content:\"\"}.hcr-connection-1-6-0 tr:first-child .hcr-connection__station-1-6-0:before{background:#fff}.hcr-connection-1-6-0 tr:first-child .hcr-connection__station-1-6-0:after{top:12px}.hcr-connection-1-6-0 tr:last-child .hcr-connection__station-1-6-0:after{bottom:calc(100% - 12px)}.hcr-connection-1-6-0 tr td:last-child{width:100%}.hcr-connection-1-6-0 td{min-width:1px;vertical-align:top}.hcr-connection--live-1-6-0 .hcr-connection__time-1-6-0{padding:0 0 0 12px;text-align:right}.hcr-connection--live-1-6-0 .hcr-connection__time-1-6-0 .hcr-connection__day-1-6-0{position:relative}.hcr-connection--live-1-6-0 .hcr-connection__station-1-6-0:after{top:-1.1em;bottom:-1.1em}.hcr-connection--live-1-6-0 tr:first-child .hcr-connection__station-1-6-0,.hcr-connection--live-1-6-0 tr:first-child td:last-child,.hcr-connection--live-1-6-0 tr:last-child .hcr-connection__station-1-6-0,.hcr-connection--live-1-6-0 tr:last-child td:last-child{font-weight:700}.hcr-connection--live-1-6-0 tr td:first-child{padding:0}.hcr-connection--live-1-6-0 tr td:first-child,.hcr-connection--live-1-6-0 tr td:only-child{width:100%}.hcr-connection--live-1-6-0 td{padding:6px 0;vertical-align:middle}.hcr-connection--live-1-6-0 .hcr-connection__station-1-6-0:before{top:50%}.hcr-connection--hide-stops-1-6-0 tr{display:none}.hcr-connection--hide-stops-1-6-0 tr:first-child,.hcr-connection--hide-stops-1-6-0 tr:last-child{display:table-row}",
map:{"hcr-connection":"hcr-connection-1-6-0","hcr-connection__station":"hcr-connection__station-1-6-0","hcr-connection__station-info":"hcr-connection__station-info-1-6-0","hcr-connection__station-toggler":"hcr-connection__station-toggler-1-6-0","hcr-connection__title":"hcr-connection__title-1-6-0","hcr-connection__title-arrival":"hcr-connection__title-arrival-1-6-0","hcr-connection__day":"hcr-connection__day-1-6-0","hcr-connection__time":"hcr-connection__time-1-6-0","hcr-connection__time--warning":"hcr-connection__time--warning-1-6-0","hcr-connection__time--old":"hcr-connection__time--old-1-6-0","hcr-connection__time--danger":"hcr-connection__time--danger-1-6-0","hcr-connection__ellipsis":"hcr-connection__ellipsis-1-6-0","hcr-connection--live":"hcr-connection--live-1-6-0","hcr-connection--hide-stops":"hcr-connection--hide-stops-1-6-0"}};

var bem = Bem('connection', styles); // disabling proptypes as they are all checked in the parent

/* eslint react/prop-types: 0 */

var Station = function Station(_ref) {
  var station = _ref.station,
      overflow = _ref.overflow;
  return React.createElement("div", {
    className: bem.e('station')
  }, overflow ? React.createElement("div", {
    className: bem.e('ellipsis')
  }, station) : station);
};
var Time = function Time(_ref2) {
  var time = _ref2.time,
      nextdays = _ref2.nextdays,
      appearance = _ref2.appearance,
      rest = _objectWithoutProperties(_ref2, ["time", "nextdays", "appearance"]);

  return React.createElement("div", _extends({
    className: bem.e('time', [appearance])
  }, rest), time, nextdays && React.createElement("span", {
    className: bem.e('day')
  }, nextdays));
};
var Info = function Info(_ref3) {
  var info = _ref3.info;
  return React.createElement("div", {
    className: bem.e('station-info')
  }, info);
};
var Toggler = function Toggler(_ref4) {
  var hideStops = _ref4.hideStops,
      toggleText = _ref4.toggleText,
      rest = _objectWithoutProperties(_ref4, ["hideStops", "toggleText"]);

  return React.createElement("div", _extends({
    className: bem.e('station-toggler')
  }, rest), hideStops && React.createElement(ButtonArrow, {
    elem: "button",
    direction: "bottom"
  }, toggleText.show), !hideStops && React.createElement(ButtonArrow, {
    elem: "button",
    direction: "top"
  }, toggleText.hide));
};

var bem$1 = Bem('connection', styles);
var Connection = function Connection(_ref) {
  var title = _ref.title,
      toggleText = _ref.toggleText,
      live = _ref.live,
      hideStops = _ref.hideStops,
      extraClasses = _ref.extraClasses,
      stops = _ref.stops,
      toggleTextProps = _ref.toggleTextProps;
  return React.createElement("table", {
    className: bem$1.b({
      'hide-stops': hideStops,
      live: live
    }, extraClasses)
  }, typeof title === 'string' && React.createElement("caption", {
    className: bem$1.e('title')
  }, title), _typeof(title) === 'object' && title && React.createElement("caption", {
    className: bem$1.e('title')
  }, "".concat(title.start, " - "), React.createElement("span", {
    className: bem$1.e('title-arrival')
  }, title.end)), React.createElement("tbody", null, stops.map(function (_ref2, index) {
    var station = _ref2.station,
        time = _ref2.time,
        arrivalTime = _ref2.arrivalTime,
        departureTime = _ref2.departureTime,
        info = _ref2.info,
        overflow = _ref2.overflow,
        liveTime = _ref2.liveTime,
        key = _ref2.key,
        rest = _objectWithoutProperties(_ref2, ["station", "time", "arrivalTime", "departureTime", "info", "overflow", "liveTime", "key"]);

    return React.createElement(React.Fragment, {
      key: key || station
    }, React.createElement("tr", rest, time && !live && React.createElement("td", null, React.createElement(Time, {
      time: time
    })), React.createElement("td", null, React.createElement(Station, {
      station: station,
      overflow: overflow
    }), info && !live && React.createElement(Info, {
      info: info
    }), toggleText && index === 0 && stops.length > 2 && React.createElement(Toggler, _extends({
      hideStops: hideStops,
      toggleText: toggleText
    }, toggleTextProps))), live && React.createElement("td", null, [arrivalTime, departureTime].filter(function (e) {
      return e != null && e.old;
    }).map(function (t) {
      return React.createElement(Time, {
        key: t.old && t.old.time,
        time: t.old && t.old.time,
        appearance: t.old && t.old.appearance,
        nextdays: t.old && t.old.nextdays
      });
    })), live && (departureTime || arrivalTime) && React.createElement("td", {
      colSpan: departureTime && departureTime.old || arrivalTime && arrivalTime.old ? 1 : 2
    }, [arrivalTime, departureTime].filter(function (e) {
      return e != null;
    }).map(function (t) {
      return React.createElement(Time, {
        key: t.current.time,
        time: t.current.time,
        nextdays: t.current.nextdays,
        appearance: t.current.appearance
      });
    }))), live && info && React.createElement("tr", null, React.createElement("td", {
      colSpan: "3"
    }, React.createElement(Info, {
      info: info
    }))));
  })));
};
Connection.displayName = 'Connection';
Connection.defaultProps = {
  title: null,
  live: false,
  extraClasses: '',
  hideStops: null,
  toggleText: null,
  toggleTextProps: {}
};
var liveTimeShape = PropTypes.shape({
  time: PropTypes.string.isRequired,
  appearance: PropTypes.oneOf([null, 'warning', 'danger', 'old']),
  nextdays: PropTypes.string
});
Connection.propTypes = {
  /** Caption (title) for this connection table */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string
  })]),

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Stops, allows for different pattern depending on live mode, see docs */
  stops: PropTypes.arrayOf(PropTypes.shape({
    info: PropTypes.string,
    station: PropTypes.string.isRequired,
    time: PropTypes.string,
    arrivalTime: PropTypes.shape({
      current: liveTimeShape,
      old: liveTimeShape
    }),
    departureTime: PropTypes.shape({
      current: liveTimeShape,
      old: liveTimeShape
    }),

    /** Optional key, otherwise "station" will be used */
    key: PropTypes.string
  })).isRequired,

  /** Hides all stops but first-last */
  hideStops: PropTypes.bool,

  /** Enables live mode, see docs */
  live: PropTypes.bool,

  /** Show/hide texts for the station toggler */
  toggleText: PropTypes.shape({
    show: PropTypes.string.isRequired,
    hide: PropTypes.string.isRequired
  }),

  /** Spread props for toggle text component */
  toggleTextProps: PropTypes.object
};
var connection = Injecss(Connection, styles);

export { connection as Connection };
